import React from "react";
import { isDesktopApp } from "../../constants/AppMethod";
import IPSVersionUp from "./IPS/IPSVersionUp";
import BMCVersionUp from "./BMC/BMCVersionUp";

const VersionUp = () => {
    const isDesktop = isDesktopApp();
    
    return (
        <div>
            {
                (isDesktop)
                ? <IPSVersionUp />
                : <BMCVersionUp />
            }
        </div>
    );
};

export default VersionUp;